export default "/assets/images/unit-slide1.jpg?b71f5c43133ace48dfb938685e0c076d";